import api from "./axios";
import formDate from "../../static/utils/js/getDate";
import md5 from "js-md5";
// import { Base64 } from "js-base64";
import { Base64 } from "js-base64";
let pares = function(data) {
  let parame = "";
  for (let key in data) {
    parame += "&" + key + "=" + data[key];
  }
  return parame.substr(1);
};
let formDate_ = formDate.getNowFormatDate();
let yc_key = md5(md5("yc1805_jz_gluce") + formDate_); //加密规则
function getdeanId() {
  return localStorage.getItem("user_deanid");
}
// let token;
// if(sessionStorage.getItem('ms_username')!=undefined){
//     token = JSON.parse(Base64.decode(sessionStorage.getItem('ms_username'))).access_token;
// }
export default {
  login(data) {
    //登录
    return api.post("Manage/loginByPassword.do?", data);
  },
  getAllMsg(data) {
    //系统消息管理--查询列表
    return api.post("dataController/getAllMsg?", data);
  },
  updateMsgState(data) {
    //系统消息管理--系统消息状态
    return api.post("dataController/updateMsgState?", data);
  },
  deleteMsg(data) {
    //系统消息管理--删除
    return api.post("dataController/deleteMsg?", data);
  },
  newAddMsg(data) {
    //系统消息管理--新增
    return api.post("dataController/insertMsg?", data);
  },
  changeMsg(data) {
    //系统消息管理--修改
    return api.post("dataController/updateMsg?", data);
  },
  getAllZx(data) {
    //资讯管理--查询列表
    return api.post("dataController/getAllZx?", data);
  },
  updateZxTjState(data) {
    //资讯管理--推荐
    return api.post("dataController/updateZxTjState?", data);
  },
  updateZxZsState(data) {
    //资讯管理--展示
    return api.post("dataController/updateZxZsState?", data);
  },
  updateZxDel(data) {
    //资讯管理--删除
    return api.post("dataController/updateZxDel?", data);
  },
  updateZxNewAdd(data) {
    //资讯管理--新增
    return api.post("dataController/insertZx?", data);
  },
  updateZxChange(data) {
    //资讯管理--修改
    return api.post("dataController/updateZx?", data);
  },
  getAllBanner(data) {
    //banner管理--查询列表
    return api.post("dataController/getAllBanner?", data);
  },
  updateBannerState(data) {
    //banner管理--状态
    return api.post("dataController/updateBannerState?", data);
  },
  deleteBanner(data) {
    //banner管理--状态
    return api.post("dataController/deleteBanner?", data);
  },
  newAddBanner(data) {
    //banner管理--新增
    return api.post("dataController/insertBanner?", data);
  },
  changeBanner(data) {
    //banner管理--修改
    return api.post("dataController/updateBanner?", data);
  },
  putAllDrug(data) {
    //药品库管理--批量导入
    return api.post("dataController/putAllDrug?", data);
  },
  getAllDrugsByTj(data) {
    //药品库管理--查询列表
    return api.post("dataController/getAllDrugsByTj?", data);
  },
  insertDrug(data) {
    //药品库管理--新增
    return api.post("dataController/insertDrug?", data);
  },
  deleteDrug(data) {
    //药品库管理--删除
    return api.post("dataController/deleteDrug?", data);
  },
  updateDrug(data) {
    //药品库管理--编辑
    return api.post("dataController/updateDrug?", data);
  },
  getAllDrgusType(data) {
    //药品库管理--获取药品所有类型
    return api.post("dataController/getAllDrugType?", data);
  },
  getAllFoodsByTj(data) {
    //食品库管理--查询列表
    return api.post("dataController/getAllFoodsByTj?", data);
  },
  insertFood(data) {
    //食品库管理--新增
    return api.post("dataController/insertFood?", data);
  },
  putAllFood(data) {
    //食品库管理--批量导入
    return api.post("dataController/putAllFood?", data);
  },
  deleteFood(data) {
    //食品库管理--删除
    return api.post("dataController/deleteFood?", data);
  },
  updateFood(data) {
    //食品库管理--编辑
    return api.post("dataController/updateFood?", data);
  },
  getAllFoodType(data) {
    //食品库管理--获取食品所有类型
    return api.post("dataController/getAllFoodType?", data);
  },

  sFManageInfo(data) {
    //随访管理--查询列表
    return api.post("Manage/sFManageInfo.do?", data);
  },
  docManageInfo(data) {
    //随访管理--医生列表
    return api.post("Manage/docManageInfo.do?", data);
  },
  newAddSF(data) {
    //随访管理--新增随访
    return api.post("Manage/delhzManageSFUserInfo.do?", data);
  },
  hzManageSFUserInfo(data) {
    //随访管理--随访
    return api.post("Manage/hzManageSFUserInfo.do?", data);
  },
  updhzManageSFUserInfo(data) {
    //随访管理--随访成功
    return api.post("Manage/updhzManageSFUserInfo.do?", data);
  },
  setSf(data) {
    //随访管理--修改成功
    return api.post("Manage/updhzManageSFUserInfo.do?", data);
  },
  //随访档案
  getSfFiles(data) {
    return api.post("followUpRecord/queryAll?", data);
  },
  //添加随访档案
  addSfFiles(data) {
    return api.post("followUpRecord/save?", data);
  },
  //修改随访档案
  editSfFiles(data) {
    return api.post("followUpRecord/update?", data);
  },
  //查询一条随访档案
  getOneSfFile(data) {
    return api.post("followUpRecord/queryAccurateUserFilesById?", data);
  },
  //删除一条随访档案
  delSfFile(data) {
    return api.post("followUpRecord/delete?", data);
  },

  // statistic(data) {
  //   //统计--血糖--顶部9大模块
  //   return api.post("manageUser/statistic.do?", data);
  // },
  // statisticTable(data) {
  //   //统计--血糖--总计
  //   return api.post("manageUser/statistic?", data);
  // },
  xtostatistic(data) {
    //统计--血糖--顶部9大模块
    return api.post("manageUser/statistic.do?", data);
  },
  //统计--血酮--总计
  xtostatisticTable(data) {
    data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("manageUser/statistic?", data);
  },
  getTableStatist(data) {
    //统计--血糖--table
    data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("manageUser/getTableStatistical", data);
  },
  getheadData(data) {
    data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("/manageUser/getTopicStatistical", data);
  },
  departmentGluce(data) {
    //统计--血糖--table
    return api.post("manageUser/departmentGluce?", data);
  },
  xtDataLine(data) {
    //统计--血糖--数据统计柱状图
    return api.post("/manageUser/departmentGluce?", data);
  },
  selectStatisticPress(data) {
    //统计--血压--顶部13大模块
    return api.post("dataController/selectStatisticPress?", data);
  },
  selectStatisticPressTable(data) {
    //统计--血压--总计
    return api.post("dataController/selectStatisticPress?", data);
  },
  selectDepartmentPress(data) {
    //统计--血糖--table
    return api.post("dataController/selectDepartmentPress?", data);
  },
  xyDataLine(data) {
    //统计--血压--数据统计柱状图
    return api.post("dataController/selectDepartmentPress?", data);
  },
  // 用户管理(医生管理/护士管理)
  DoctorManagement(data) {
    //用户管理--医生管理--查询列表
    return api.get("RoutineUserController/DoctorManagement.do?" + pares(data));
  },
  user_departmentlist(data) {
    //用户管理--医生管理--下级机构
    return api.get(
      "RoutineUserController/user_departmentlist.do?" + pares(data)
    );
  },
  AddNurse(data) {
    //用户管理--医生管理--未知
    return api.post("RoutineUserController/AddNurse.do?", data);
  },
  modificationPswd(data) {
    //用户管理--医生管理--未知
    return api.get("RoutineUserController/modificationPswd.do?" + pares(data));
  },
  RemoveDoctor(data) {
    //用户管理--医生管理--删除
    return api.post("RoutineUserController/RemoveDoctor.do?", data);
  },
  NurseStateUpdate(data) {
    //用户管理--医生管理--未知
    return api.post("RoutineUserController/NurseStateUpdate.do?", data);
  },
  NurseList(data) {
    //用户管理--护士管理--查询列表
    return api.get("RoutineUserController/NurseManagement.do?" + pares(data));
  },
  userListks(data) {
    //用户管理--护士管理--查询列表
    return api.get(
      "RoutineUserController/user_departmentlist.do?" + pares(data)
    );
  },
  AddNurseList(data) {
    //用户管理--护士管理--新增
    return api.post("RoutineUserController/AddNurse.do?", data);
  },
  modificationPswdList(data) {
    //用户管理--护士管理--未知
    return api.get("RoutineUserController/modificationPswd.do?" + pares(data));
  },
  deleteNurse(data) {
    //用户管理--护士管理--删除
    return api.post("RoutineUserController/deleteNurse.do?", data);
  },
  NurseStateList(data) {
    //用户管理--护士管理--set
    return api.post("RoutineUserController/NurseStateUpdate.do?", data);
  },
  // 信息管理--试条用户量统计
  stripUserList(data) {
    //信息管理--试条用户量统计--查询列表
    return api.post("manageUser/stripUser?", data);
  },
  departmentList(data) {
    //信息管理--试条用户量统计--XXX
    return api.post("manageUser/department?", data);
  },
  // 信息管理--护士工作统计
  nurseWorkList(data) {
    //信息管理--试条用户量统计--XXX
    return api.post("manageUser/nurseWork?", data);
  },
  nurseList(data) {
    //信息管理--试条用户量统计--XXX
    return api.post("manageUser/nurseWork?", data);
  },
  // 质量管理--试条管理
  stqualityList(data) {
    //质量管理--试条管理--列表查询
    return api.post("manageUser/qualityControl?", data);
  },
  zkyqualityList(data) {
    //质量管理--试条管理--列表查询
    return api.post("manageUser/qualityControl?", data);
  },
  bzqualityList(data) {
    //质量管理--试条管理--列表查询
    return api.post("manageUser/qualityControl?", data);
  },
  deleteQualityContol(data) {
    //质量管理--试条管理--列表查询
    return api.post("manageUser/deleteQualityContol?", data);
  },
  insertTestStrip(data) {
    //质量管理--试条管理--列表查询
    return api.post("doctorUser/insertTestStrip?", data);
  },
  insertQualityFluid(data) {
    //质量管理--试条管理--列表查询
    return api.post("doctorUser/insertQualityFluid?", data);
  },
  updateQcfInfo(data) {
    //质量管理--试条管理--列表查询
    return api.post("doctorUser/updateQcfInfo.do?", data);
  },
  // 质量管理--仪器管理
  gluceMeterList(data) {
    //质量管理--仪器管理--列表查询(废弃)
    return api.post("manageUser/gluceMeter?", data);
  },

  newsGluceMeterList(data) {
    //质量管理--仪器管理--列表查询
    return api.post("dataController/getInstrumentByDeanid?", data);
  },
  delGluceStatus(data) {
    //质量管理--仪器管理--作废
    return api.post("dataController/updateInstrument_e_status?", data);
  },
  yqdepartment(data) {
    //质量管理--仪器管理--
    return api.post("manageUser/department?", data);
  },
  insertGluceMeter(data) {
    //质量管理--仪器管理--
    return api.post("doctorUser/insertGluceMeter?", data);
  },
  updateMeter(data) {
    //质量管理--仪器管理--
    return api.post("manageUser/updateMeter?", data);
  },
  deleteyq(data) {
    //质量管理--仪器管理--
    return api.post("manageUser/deleteQualityContol?", data);
  },
  // 质量管理--质控数据维护
  table1(data) {
    //质量管理--质控数据维护--表一
    return api.post("manageUser/qualityTable?", data);
  },
  table2(data) {
    //质量管理--质控数据维护--表二
    return api.post("manageUser/zkywh?", data);
  },
  listZky(data) {
    //质量管理--质控数据维护--获取试条批号列表
    return api.post("manageUser/qualityControl?", data);
  },
  hsList(data) {
    //质量管理--质控数据维护--护士
    return api.get("RoutineUserController/NurseManagement.do?" + pares(data));
  },
  docList(data) {
    //质量管理--质控数据维护--医生
    return api.get("RoutineUserController/DoctorManagement.do?" + pares(data));
  },
  updateZkywhList(data) {
    //质量管理--质控数据维护--获取质控液批号列表
    return api.post("manageUser/updateZkywh?", data);
  },
  deleteQ(data) {
    //质量管理--质控数据维护--删除
    return api.post("manageUser/deleteQualityContol?", data);
  },
  departList(data) {
    //质量管理--质控数据维护--xxx
    return api.post("manageUser/department?", data);
  },
  departList(data) {
    //质量管理--质控数据维护--xxx
    return api.post("manageUser/department?", data);
  },
  zkyTypeData(data) {
    //质量管理--质控柱状图
    return api.post("manageUser/zkyType?", data);
  },
  //基本信息设置
  manageDetail(data) {
    //基本信息设置--机构信息
    return api.post("manageUser/manageDetail?", data);
  },
  setInfo(data) {
    //基本信息设置--机构信息
    return api.post("manageUser/updateManage?", data);
  },
  depList(data) {
    //基本信息设置--下级机构列表
    return api.post("manageUser/department?", data);
  },
  deleteDep(data) {
    //基本信息设置--下级机构列表--删除
    return api.post("manageUser/deleteDepartment?", data);
  },
  updateDep(data) {
    //基本信息设置--下级机构列表--xx
    return api.post("manageUser/updateDepartment?", data);
  },
  insertDep(data) {
    //基本信息设置--下级机构列表--xx
    return api.post("manageUser/insertDepartment?", data);
  },
  TableA(data) {
    //基本信息设置--参数设置--tableABCDE
    return api.post("manageUser/sugarParam?", data);
  },
  updatePre(data) {
    //基本信息设置--参数设置--2
    return api.post("manageUser/updatePreParam?", data);
  },
  updateBk(data) {
    //基本信息设置--参数设置--3
    return api.post("manageUser/updateBkParam?", data);
  },
  updateOxy(data) {
    //基本信息设置--参数设置--4
    return api.post("dataController/updateOxyParam?", data);
  },
  updateBua(data) {
    //基本信息设置--参数设置--5
    return api.post("dataController/updateBuaParam?", data);
  },
  updateUt(data) {
    //基本信息设置--参数设置--6
    return api.post("dataController/updateUtParam?", data);
  },
  updateTem(data) {
    //基本信息设置--参数设置--7
    return api.post("manageUser/updateTemParam?", data);
  },
  updateHem(data) {
    //基本信息设置--参数设置--8
    return api.post("dataController/updateHemParam?", data);
  },
  updateBf(data) {
    //基本信息设置--参数设置--9
    return api.post("dataController/updateBfParam?", data);
  },
  updateSugar(data) {
    //基本信息设置--参数设置--xx
    return api.post("manageUser/updateSugar?", data);
  },
  // 模板管理
  template(data) {
    //基本信息设置--模板管理--xx
    return api.post("manageUser/template?", data);
  },
  addTemplate(data) {
    //基本信息设置--模板管理--xx
    return api.post("manageUser/addTemplate?", data);
  },
  updateTemplate(data) {
    //基本信息设置--模板管理--xx
    return api.post("manageUser/updateTemplate?", data);
  },
  deleteTemplate(data) {
    //基本信息设置--模板管理--xx
    return api.post("manageUser/deleteTemplate?", data);
  },
  // 数据管理
  updateUserData(data) {
    //数据管理--修改
    return api.post("manageUser/updateUserData?", data);
  },
  deleteUserData(data) {
    //数据管理--删除
    return api.post("manageUser/deleteUserData?", data);
  },
  gluceUserList(data) {
    //数据管理--xx
    return api.post("manageUser/gluceUser?", data);
  },
  ksList(data) {
    //数据管理--获取下级机构列表
    return api.post("manageUser/department?", data);
  },
  ysList(data) {
    //数据管理--获取医生列表
    return api.post("Manage/docManageInfo.do?", data);
  },
  // 首页
  homeTopList(data) {
    //首页--血糖顶部9大块
    return api.post("Manage/homePageData.do?", data);
  },
  xyTopList(data) {
    //首页--血压顶部9大块
    return api.post("dataController/getAllXueYaByType?", data);
  },
  xttTopList(data) {
    //首页--血酮体顶部9大块
    return api.post("dataController/getAllXueTongTiById.do?", data);
  },
  oxyTopList(data) {
    //首页--血氧顶部9大块
    return api.post("dataController/getAllXueYangById.do?", data);
  },
  uricTopList(data) {
    //首页--血尿酸顶部9大块
    return api.post("dataController/getAllBuaById?", data);
  },
  utraceTopList(data) {
    //首页--尿微量顶部9大块
    return api.post("dataController/getAllUtById?", data);
  },
  temTopList(data) {
    //首页--体温顶部9大块
    return api.post("dataController/getAllTiWenById?", data);
  },
  gproteinTopList(data) {
    //首页--血红蛋白顶部9大块
    return api.post("dataController/getAllHemoglobinByType?", data);
  },
  blloodfatTopList(data) {
    //首页--血脂顶部9大块
    return api.post("dataController/getAllBfById?", data);
  },
  // 首页--血糖--表格管理
  homeDataGList(data) {
    // 首页--血糖报告--严重高血糖/低血糖(表格管理)
    return api.post("Manage/homePageGDData.do?", data);
  },
  homeDataGetDoc(data) {
    // 首页--血糖报告--
    return api.post("Manage/docManageInfo.do?", data);
  },
  homeDataCode(data) {
    // 首页--血糖报告--
    return api.post("Manage/ZdTemInfo.do?", data);
  },
  homeDataTemList(data) {
    // 首页--血糖报告--
    return api.post("Manage/temManageList.do?", data);
  },
  homeDataZDH(data) {
    // 首页--血糖报告--
    return api.post("Manage/zDHzManageInfo.do?", data);
  },
  homeDataGyInfo(data) {
    // 首页--血糖报告--干预保存
    return api.post("Manage/insHzGyInfo.do?", data);
  },
  homeDataTxInfo(data) {
    // 首页--血糖报告--提醒保存
    return api.post("Manage/insHzTxInfo.do?", data);
  },
  homeDataSfInfo(data) {
    data.follow_lx = 0;
    // 首页--血糖报告--随访保存
    return api.post("Manage/insHzSfInfo.do?", data);
  },
  homeDataPGdata(data) {
    // 首页--血糖总览--评估信息table/柱状图
    return api.post("Manage/homePageGlPGdata.do?", data);
  },
  // 首页--血压--表格管理
  pressureGList(data) {
    // 首页--血压报告--严重高血压/低血压(表格管理)
    return api.post("dataController/getAllXueYaByType?", data);
  },
  pressureGlPGdata(data) {
    // 首页--血压总览--评估信息table/柱状图
    return api.post("dataController/pressureGlPGdata?", data);
  },
  xttTableList(data) {
    // 首页--血酮体--表格管理
    return api.post("dataController/getAllXueTongTiById.do?", data);
  },
  xttTableDelete(data) {
    // 首页--血酮体--删除
    return api.post("dataController/deleteBkValue?", data);
  },
  xttTableNewAdd(data) {
    // 首页--血酮体--新增
    return api.post("doctorUser/insertBk?", data);
  },
  xttTableUpdate(data) {
    // 首页--血酮体--修改
    return api.post("dataController/updateBkValue?", data);
  },
  oxyTableList(data) {
    // 首页--血氧--表格管理
    return api.post("dataController/getAllXueYangById.do?", data);
  },
  oxyTableDelete(data) {
    // 首页--血氧--删除
    return api.post("dataController/deleteOxyValue?", data);
  },
  oxyTableNewAdd(data) {
    // 首页--血氧--新增
    return api.post("dataController/insertOxy?", data);
  },
  oxyTableUpdate(data) {
    // 首页--血氧--修改
    return api.post("dataController/updateOxyValue?", data);
  },
  uricAcidTableList(data) {
    // 首页--血尿酸--表格管理
    return api.post("dataController/getAllBuaById?", data);
  },
  uricAcidTableDelete(data) {
    // 首页--血尿酸--删除
    return api.post("dataController/deleteBuaValue?", data);
  },
  uricAcidTableNewAdd(data) {
    // 首页--血尿酸--新增
    return api.post("dataController/insertBua?", data);
  },
  uricAcidTableUpdate(data) {
    // 首页--血尿酸--修改
    return api.post("dataController/updateBuaValue?", data);
  },
  utraceTableList(data) {
    // 首页--尿微量--表格管理
    return api.post("dataController/getAllUtById?", data);
  },
  utraceTableDelete(data) {
    // 首页--尿微量--删除
    return api.post("dataController/deleteUtValue?", data);
  },
  utraceTableNewAdd(data) {
    // 首页--尿微量--新增
    return api.post("dataController/insertUt?", data);
  },
  utraceTableUpdate(data) {
    // 首页--尿微量--修改
    return api.post("dataController/updateUtValue?", data);
  },
  temperatureTableList(data) {
    // 首页--体温--表格管理
    return api.post("dataController/getAllTiWenById?", data);
  },
  temperatureTableDelete(data) {
    // 首页--体温--删除
    return api.post("dataController/deleteTemValue?", data);
  },
  temperatureTableNewAdd(data) {
    // 首页--体温--新增
    return api.post("dataController/insertTem?", data);
  },
  temperatureTableUpdate(data) {
    // 首页--体温--修改
    return api.post("dataController/updateTemValue?", data);
  },
  GproteinTableList(data) {
    // 首页--血红蛋白--表格管理
    return api.post("dataController/getAllHemoglobinByType?", data);
  },
  GproteinTableDelete(data) {
    // 首页--血红蛋白--删除
    return api.post("dataController/deleteHemoglobinValue?", data);
  },
  GproteinTableNewAdd(data) {
    // 首页--血红蛋白--新增
    return api.post("dataController/insertHem?", data);
  },
  GproteinTableUpdate(data) {
    // 首页--血红蛋白--修改
    return api.post("dataController/updateHemoglobinValue?", data);
  },
  bloodfatTableList(data) {
    // 首页--血脂--表格管理
    return api.post("dataController/getAllBfById?", data);
  },
  bloodfatTableDelete(data) {
    // 首页--血脂--删除
    return api.post("dataController/deleteBfValue?", data);
  },
  bloodfatTableNewAdd(data) {
    // 首页--血脂--新增
    return api.post("dataController/insertBf?", data);
  },
  bloodfatTableUpdate(data) {
    // 首页--血脂--修改
    return api.post("dataController/updateBf?", data);
  },
  // 患者管理
  keshiList(data) {
    // 患者管理--下级机构列表
    return api.post("manageUser/department.do?", data);
  },
  hzManageInfoList(data) {
    // 患者管理--
    return api.post("Manage/hzManageInfo.do?", data);
  },
  docManageInfoList(data) {
    // 患者管理--
    return api.post("Manage/docManageInfo.do?", data);
  },
  zDHzData(data) {
    // 患者管理--
    return api.post("Manage/zDHzManageInfo.do?", data);
  },
  insHzGyAllInfo(data) {
    data.gid = getdeanId();
    // 患者管理--
    return api.post("Manage/insHzGyAllInfo.do?", data);
  },
  insHzGydgInfo(data) {
    data.gid = getdeanId();
    // 患者管理--单个
    return api.post("Manage/insHzGyInfo.do?", data);
  },
  insHzTxAllInfo(data) {
    data.gid = getdeanId();
    // 患者管理--单个
    return api.post("Manage/insHzTxAllInfo.do?", data);
  },
  insHzTxdgInfo(data) {
    data.gid = getdeanId();
    // 患者管理--单个
    return api.post("Manage/insHzTxInfo.do?", data);
  },
  insHzSfAllInfo(data) {
    data.gid = getdeanId();

    // 患者管理--单个
    return api.post("Manage/insHzSfAllInfo.do?", data);
  },
  insHzSfdgInfo(data) {
    data.gid = getdeanId();
    // 患者管理--单个
    return api.post("Manage/insHzSfInfo.do?", data);
  },
  // 获取干预模板列表
  getGYList(data) {
    // 患者管理--单个
    return api.post("Manage/temManageList.do?", data);
  },
  xialaList(data) {
    // 患者管理--单个
    return api.post("Manage/ZdTemInfo.do?", data);
  },
  docxlData(data) {
    // 患者管理--单个
    return api.post("Manage/docManageInfo.do?", data);
  },
  deHzInfoData(data) {
    // 患者管理--下级机构列表
    return api.post("Manage/deManageHzInfo.do?", data);
  },
  // 新增医生
  uploadData(data) {
    // 新增医生--上传图片
    return api.post("RoutineUserController/file_upload1.do?", data);
  },
  uploadData22(data) {
    // 新增医生--上传图片
    return api.post("Manage/facePicUplod.do?", data);
  },
  AddDoctor(data) {
    // 新增医生
    return api.post("RoutineUserController/AddDoctor.do?", data);
  },
  DoctorManagementDetails(data) {
    // 新
    return api.get(
      "RoutineUserController/DoctorManagementDetails.do?" + pares(data)
    );
  },

  UpdateDoctorInfo(data) {
    // 修改
    return api.post("RoutineUserController/UpdateDoctorInfo.do?", data);
  },
  // 患者详情
  patientDetailsData(data) {
    // 患者详情
    return api.post("RoutineUserController/CancelAnchorPoint.do?", data);
  },
  patientDetailszDHzData(data) {
    // 患者详情
    return api.post("Manage/zDHzManageXxInfo.do?", data);
  },
  // 大数据
  bigDataNumber(data) {
    // 大数据
    return api.post("Manage/NumbiInfo.do?", data);
  },
  bigDataStatis(data) {
    // 大数据--测量情况
    return api.post("dataController/bigDataStatistics?", data);
  },
  bigDataBiInfo(data) {
    // 大数据--排名
    return api.post("Manage/biInfo.do?", data);
  },
  bigDataBar(data) {
    // 大数据--数据统计(柱状图)
    return api.post("dataController/bigDataBar?", data);
  },
  bigDataAgeAndSex(data) {
    // 大数据--性别年龄占比图(柱状图)
    return api.post("dataController/bigDataAgeAndSex?", data);
  },
  bigDataDis(data) {
    // 大数据--折线图(柱状图)
    return api.post("dataController/bigDataDis?", data);
  },
  bigDataScorllMsg(data) {
    // 大数据--实时监测
    return api.post("dataController/bigDataMonitor?", data);
  },
  // 预警
  gluceWarning(data) {
    // 大数据--实时监测
    return api.get("RoutineUserController/gluceWarning.do?" + pares(data));
  },
  // 地区三级联动
  Threelevellinkage(data) {
    // 地区三级联动
    return api.post("RoutineUserController/Threelevellinkage.do?", data);
  },
  // 查看患者饮食、运动、吸烟、用药推荐模板
  getAllTempByUserid(data) {
    return api.post("userAllDataController/getAllTempByUserid?", data);
  },
  // 食品管理：查看所有类型
  getFoodType(data) {
    return api.post("dataController/getAllFoodType?", data);
  },
  // 患者档案：修改患者饮食模板
  updateUserFoodTemp(data) {
    return api.post("userAllDataController/updateUserFoodTemp?", data);
  },
  // 患者档案：修改患者运动模板
  updateUserSportTemp(data) {
    return api.post("userAllDataController/updateUserSportTemp?", data);
  },
  // 患者档案：修改患者吸烟模板
  updateUserSmokeTemp(data) {
    return api.post("userAllDataController/updateUserSmokeTemp?", data);
  },
  // 患者档案：修改患者用药模板
  updateUserDrugTemp(data) {
    return api.post("userAllDataController/updateUserDrugTemp?", data);
  },
  // 患者档案：查看所有运动
  getAllSportAndTypeByDeanid(data) {
    return api.post("userAllDataController/getAllSportAndTypeByDeanid?", data);
  },
  // 患者档案：查看所有烟草
  getAllSmoke(data) {
    return api.post("userAllDataController/getAllSmoke?", data);
  },
  // 患者档案：吸烟用药过量警告
  deanSenderMsgByUser(data) {
    return api.post("userAllDataController/deanSenderMsgByUser?", data);
  },
  // 患者档案：查看所有民族
  getAllNation(data) {
    return api.post("userAllDataController/getAllNation?", data);
  },
  // 患者档案：查看机构下的所有胰岛素
  getAllInsulin(data) {
    return api.post("userAllDataController/getAllInsulin?", data);
  },
  // 患者档案：下级机构医生，二级联动
  departmentAndDoctor(data) {
    return api.post("userAllDataController/departmentAndDoctor?", data);
  },
  // 患者档案：新增患者档案
  addInsertUser(data) {
    return api.post("userAllDataController/insertUser?", data);
  },
  // 患者档案：修改患者档案
  updateUser(data) {
    return api.post("userAllDataController/updateUser?", data);
  },
  // 患者详情--接口
  patientGluce(data) {
    // 添加Gluce
    return api.post("doctorUser/insertGluce?", data);
  },
  patientPressure(data) {
    // 添加Pressure
    return api.post("doctorUser/insertPressure?", data);
  },
  patientBk(data) {
    // 添加Bk
    return api.post("doctorUser/insertBk?", data);
  },
  patientTem(data) {
    // 添加Tem
    return api.post("doctorUser/insertTem?", data);
  },
  changepr(data) {
    // 修改
    return api.post("Manage/updhzManagePrData.do?", data);
  },
  changeBk(data) {
    // 修改
    return api.post("Manage/updhzManageBkData.do?", data);
  },
  changeTem(data) {
    // 修改
    return api.post("Manage/updhzManageTemData.do?", data);
  },
  delPr(data) {
    // 删除
    return api.post("Manage/delhzManagePrData.do?", data);
  },
  delBk(data) {
    // 删除
    return api.post("Manage/delhzManageBkData.do?", data);
  },
  delTem(data) {
    // 删除
    return api.post("Manage/delhzManageTemData?", data);
  },
  hzManageXxBGGlInfo(data) {
    //列表
    return api.post("Manage/hzManageXxBGGlInfo1.do?", data);
  },
  XxGlInfo(data) {
    //图表
    return api.post("Manage/hzManageXxGlInfo.do?", data);
  },
  XxGluce(data) {
    //图表--添加
    return api.post("doctorUser/insertGluce?", data);
  },
  XxPressure(data) {
    //图表--添加
    return api.post("doctorUser/insertPressure?", data);
  },
  XxBk(data) {
    //图表--添加
    return api.post("doctorUser/insertBk?", data);
  },
  XxTem(data) {
    //图表--添加
    return api.post("doctorUser/insertTem?", data);
  },
  hzManageXxRptGlInfo(data) {
    //图表--添加
    return api.post("Manage/hzManageXxRptGlInfo.do", data);
  },
  hzManageGYGlInfo(data) {
    //记录
    return api.post("Manage/hzManageGYGlInfo.do", data);
  },
  hzManageSFGlInfo(data) {
    //记录
    return api.post("Manage/hzManageSFGlInfo.do", data);
  },
  hzManageTXGlInfo(data) {
    //记录
    return api.post("Manage/hzManageTXGlInfo.do", data);
  },
  // 患者详情:
  getUserAllDataByid(data) {
    //记录
    return api.post("userAllDataController/getUserAllDataByid", data);
  },
  getUserAllEatManage(data) {
    //患者档案：查看患者饮食记录
    return api.post("userAllDataController/getUserAllEatManage", data);
  },
  getUserAllSportManage(data) {
    //患者档案：查看患者运动记录
    return api.post("userAllDataController/getUserAllSportManage", data);
  },
  getUserAllDrugManage(data) {
    //患者档案：查看患者用药记录
    return api.post("userAllDataController/getUserAllDrugManage", data);
  },
  getUserAllSmokeManage(data) {
    //患者档案：查看患者吸烟记录
    return api.post("userAllDataController/getUserAllSmokeManage", data);
  },
  // 药品库：类别二级分类
  drugTypeTwoRank(data) {
    return api.post("dataController/drugTypeTwoRank", data);
  },

  // 解绑仪器
  unbundling(data) {
    return api.post("RoutineUserController/RelieveEquipment.do", data);
  },

  // 更新备注信息(血糖、血压 new add string )
  updateRemark(data) {
    return api.post("Manage/updateRemark.do", data);
  },

  // 查询备注信息(血糖、血压 new add string )
  queryRemark(data) {
    return api.post("Manage/queryRemark.do", data);
  },

  // 总后台接口:
  saveDeanInf(data) {
    //机构账号管理：新增
    return api.post("deanController/saveDeanInf.do", data);
  },
  listDeanAndUser(data) {
    //机构账号管理：列表
    return api.post("deanController/listDeanAndUser.do", data);
  },
  removeDeanAndUser(data) {
    //机构账号管理：删除
    return api.post("deanController/removeDeanAndUser.do", data);
  },
  updateUserStatus(data) {
    //机构账号管理：禁用
    return api.post("deanController/updateUserStatus.do", data);
  },
  updateDeanAndUserInfo(data) {
    //机构账号管理：修改
    return api.post("deanController/updateDeanAndUserInfo.do", data);
  },

  listDeanbd(data) {
    //大数据管理：列表
    return api.post("deanController/listDeanbd.do", data);
  },
  updateDeanCoordinate(data) {
    //大数据管理：编辑
    return api.post("deanController/updateDeanCoordinate.do", data);
  },

  undistributed(data) {
    //查询未分配的设备号
    return api.post("equipment/listEquipmentNoDistribution", data);
  },
  allocated(data) {
    //查询已分配的设备号
    return api.post("equipment/listEquipmentIsDistribution", data);
  },
  addEquipment(data) {
    //新增设备
    return api.post("equipment/save", data);
  },
  saveFile(data) {
    //excel批量导入设备
    return api.post("equipment/saveFile", data);
  },
  distributionSave(data) {
    //分配设备
    return api.post("equipment/equipmentDistribution", data);
  },
  upEquipment(data) {
    //更新设备编辑
    return api.post("equipment/update", data);
  },
  delEquipment(data) {
    //删除设备
    return api.post("equipment/remove", data);
  },
  listDeanName(data) {
    //三级联动获取院长id和名字
    return api.post("deanController/listDeanName", data);
  },
  listDepartmentName(data) {
    //三级联动获取门店id和名字
    return api.post("deanController/listDepartmentName.do", data);
  },
  listDocName(data) {
    //三级联动获取医健康专员id和名字
    return api.post("deanController/listDoctorName", data);
  },
  getoutDemo(data) {
    return api.post("UploadVerificationController/queryBooldPress", data);
  },

  // 下级机构接口:
  dpgetAllFoodsByTj(data) {
    //下级机构-食品库管理--查询列表
    return api.post("dataController/getAllFoodsByTj?", data);
  },
  dpinsertFood(data) {
    //下级机构-食品库管理--新增
    return api.post("dataController/insertFood?", data);
  },
  dpdeleteFood(data) {
    //下级机构-食品库管理--删除
    return api.post("dataController/deleteFood?", data);
  },
  dpupdateFood(data) {
    //下级机构-食品库管理--编辑
    return api.post("dataController/updateFood?", data);
  },
  dpgetAllFoodType(data) {
    //下级机构-食品库管理--获取食品所有类型
    return api.post("dataController/getAllFoodType?", data);
  },

  dpgetAllDrugsByTj(data) {
    //下级机构-药品库管理--查询列表
    return api.post("dataController/getAllDrugsByTj?", data);
  },
  dpinsertDrug(data) {
    //下级机构-药品库管理--新增
    return api.post("dataController/insertDrug?", data);
  },
  dpdeleteDrug(data) {
    //下级机构-药品库管理--删除
    return api.post("dataController/deleteDrug?", data);
  },
  dpupdateDrug(data) {
    //下级机构-药品库管理--编辑
    return api.post("dataController/updateDrug?", data);
  },
  dpgetAllDrgusType(data) {
    //药品库管理--获取药品所有类型
    return api.post("dataController/getAllDrugType?", data);
  },
  dphomeDataGList(data) {
    // 下级机构首页--血糖报告--严重高血糖/低血糖(表格管理)
    return api.post("Manage/homePageGDData.do?", data);
  },
  dphzManageInfoList(data) {
    // 患者管理--
    return api.post("Manage/hzManageInfo.do?", data);
  },

  // 小程序下单H5页面获取数据
  wxOrder(data) {
    return api.post("CtwingGluceDataController/wxPay.do", data);
  },

  // 新增充值管理
  getEqSimOrderByterm(data) {
    return api.post("equipment/getEqSimOrderByterm", data);
  },
  // 获取所有套餐
  getAllCombo(data) {
    return api.post("equipment/getAllCombo", data);
  },
  // 修改缴存状态
  updateSimPayOrderStatus(data) {
    return api.post("equipment/updateSimPayOrderStatus", data);
  },
  // 修改BMI/腰围状态
  updateBMIParam(data) {
    return api.post("dataController/updateBmiWaiParam.do", data);
  },
  // 修改心电状态
  updateEcgParam(data) {
    return api.post("manageUser/updateEcgParam.do", data);
  },
  // 添加患者BMI/腰围状态
  insertBmiAndWai(data) {
    return api.post("dataController/insertBmiAndWai.do", data);
  },
  // 修改患者BMI/腰围状态
  updateBmiAndWaiValue(data) {
    return api.post("dataController/updateBmiAndWaiValue.do", data);
  },
  // 删除BMI/腰围状态
  deleteBmiAndWaiValue(data) {
    return api.post("dataController/deleteBmiAndWaiValue.do", data);
  },
  // 删除心电数据
  deleteEcgValue(data) {
    return api.post("/dataController/deleteEcgValue?", data);
  },
  // 查询心电图
  getEcgOscillogram(data) {
    return api.post("/ECG/getEcgOscillogram.do", data);
  },
  //上传图片(新)
  fileUpload(data) {
    //  data.graphicUpload=true
    data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("dataController/uploadFilePic", data);
  },
  //批量导入患者(新)
  importDeviceFromExcel(data) {
    //  data.graphicUpload=true
    // data.deanid = getdeanId();
    (data.graphicUpload = true), (data.ycgl_key = yc_key);
    // console.log(data);
    return api.post("dataController/importDeviceFromExcel", data);
  },
  //查询对账列表
  getAccountChecking(data) {
    // data.deanid = getdeanId();
    // data.ycgl_key = yc_key;
    return api.post("accountChecking/accountCheckingPageList", data);
  },
  //查询对账列表(不带分页)
  getAccountCheckingNotPage(data) {
    // data.deanid = getdeanId();
    // data.ycgl_key = yc_key;
    return api.post("accountChecking/accountCheckingList", data);
  },
  //修改兑费状态
  updateDFStatus(data) {
    // data.deanid = getdeanId();
    // data.ycgl_key = yc_key;
    return api.post("accountChecking/updateDFStatus", data);
  },
  //导出兑费excel
  exportDFExcel(data) {
    data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("accountChecking/exportAccountCheckingList", data);
  },
  // 总后台获取科室下拉带模糊搜索
  getDepartmentList(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("manageUser/departmentGluceNotInYz", data);
  },

  // 用户商品列表查询
  getUserProduct(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/queryCommodityList", data);
  },
  // 查询用户商品详情
  getUserProductDetails(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/queryCommodityDetails", data);
  },
  // 添加用户商品
  addUserProduct(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/saveCommodity", data);
  },
  // 修改用户商品
  editUserProduct(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/updateCommodity", data);
  },
  // 修改用户商品状态
  changeUserProductStatus(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/updateCommoditySeeStatus", data);
  },
  // 删除用户商品
  delUserProduct(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/deleteCommodity", data);
  },
  // 积分商品列表查询
  getIntegralrProduct(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/queryJfCommodityList", data);
  },
  // 查询用户商品详情
  getIntegralrProductDetails(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/queryJfCommodityDetails", data);
  },
  // 添加积分商品
  addIntegralrProduct(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/saveJfCommodity", data);
  },
  // 修改积分商品
  editIntegralrProduct(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/updateJfCommodity", data);
  },
  // 修改积分商品状态
  changeIntegralrProductStatus(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/updateJfCommoditySeeStatus", data);
  },
  // 删除积分商品
  delIntegralrProduct(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("commodity/deleteJfCommodity", data);
  },
  // 用户订单列表查询
  getUserOrderList(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("orderSystem/yyCommodityList", data);
  },
  // 用户订单查询详情
  getUserOrderDetail(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("orderSystem/yyCommodityOrderDetails", data);
  },
  // 取消用户订单
  cancelUserOrder(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("orderSystem/yyCommodityQxOrder", data);
  },
  // 完成用户订单
  completeUserOrder(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("orderSystem/yyCommodityWcOrder", data);
  },
  // 积分订单列表查询
  getIntegralrOrderList(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("orderSystem/yyCommodityJfList", data);
  },
  // 积分订单查询详情
  getJFOrderDetail(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("orderSystem/yyCommodityJfOrderDetails", data);
  },
  // 取消积分订单
  cancelJFOrder(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("orderSystem/yyCommodityJfQxOrder", data);
  },
  // 完成积分订单
  completeJFOrder(data) {
    // data.deanid = getdeanId();
    data.ycgl_key = yc_key;
    return api.post("orderSystem/yyCommodityJfWcOrder", data);
  },
};



// WEBPACK FOOTER //
// ./src/api/api.js